import { render, staticRenderFns } from "./instructionEdit.vue?vue&type=template&id=5c4c6f48"
import script from "./instructionEdit.vue?vue&type=script&lang=js"
export * from "./instructionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports